import styled, { css } from 'styled-components';

// Sits under the sticky Back header, like the session screen, so "Back to
// Path" stays reachable.
export const Screen = styled.div(
  ({ theme }) => css`
    position: fixed;
    inset: 0;
    z-index: ${theme.zi.z1};
    background-color: ${theme.co.tertiary0};
    overflow: hidden;
  `,
);

export const Panel = styled.div(
  ({ theme }) => css`
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${theme.sz.s4};
    padding: ${theme.sz.s20} ${theme.sz.s6} ${theme.sz.s8};
    text-align: center;
    overflow-y: auto;

    @media (max-width: ${theme.sz.md}) {
      padding: ${theme.sz.s16} ${theme.sz.s4} ${theme.sz.s6};
    }
  `,
);

export const FreeLessonPill = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s2};
    padding: ${theme.sz.s2} ${theme.sz.s4};
    border-radius: ${theme.bo.round};
    background-color: ${theme.co.primary20};
    color: ${theme.co.secondary0};
    ${theme.typography.heading.desktop.xxs};

    svg {
      font-size: ${theme.sz.s4};
    }
  `,
);

export const Title = styled.h1(
  ({ theme }) => css`
    margin: ${theme.sz.s0};
    color: ${theme.co.neutral99};
    text-shadow: 0 ${theme.sz.s05} ${theme.sz.s2} rgb(0 17 34 / 45%);
    ${theme.typography.heading.desktop.xxl};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.l};
    }
  `,
);

export const Description = styled.p(
  ({ theme }) => css`
    max-width: ${theme.sz.ms};
    margin: ${theme.sz.s0};
    color: ${theme.co.neutral99};
    opacity: 0.9;
    ${theme.typography.paragraph.l};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.base};
    }
  `,
);

export const WordChips = styled.div(
  ({ theme }) => css`
    max-width: ${theme.sz.lg};
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: ${theme.sz.s3};
    margin-top: ${theme.sz.s2};
  `,
);

export const WordChip = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: baseline;
    gap: ${theme.sz.s2};
    padding: ${theme.sz.s2} ${theme.sz.s4};
    border: ${theme.bo.thinWidth} solid rgb(255 255 255 / 35%);
    border-radius: ${theme.bo.round};
    background-color: rgb(255 255 255 / 10%);
  `,
);

export const ChipTarget = styled.span(
  ({ theme }) => css`
    color: ${theme.co.neutral99};
    ${theme.typography.heading.desktop.xxs};
  `,
);

export const ChipSource = styled.span(
  ({ theme }) => css`
    color: ${theme.co.neutral99};
    opacity: 0.7;
    ${theme.typography.paragraph.m};
  `,
);

export const StartButton = styled.button(
  ({ theme }) => css`
    min-width: ${theme.sz.xs};
    margin-top: ${theme.sz.s4};
    padding: ${theme.sz.s4} ${theme.sz.s8};
    border: none;
    border-radius: ${theme.bo.round};
    background-color: ${theme.co.primary20};
    color: ${theme.co.secondary0};
    cursor: pointer;
    ${theme.typography.heading.desktop.xs};

    &:hover {
      background-color: ${theme.co.primary10};
    }

    @media (max-width: ${theme.sz.md}) {
      width: 100%;
      min-width: unset;
    }
  `,
);

export const ContinueLearningLink = styled.button(
  ({ theme }) => css`
    padding: ${theme.sz.s2};
    border: none;
    background: none;
    color: ${theme.co.neutral99};
    text-decoration: underline;
    cursor: pointer;
    ${theme.typography.paragraph.m};

    &:disabled {
      opacity: 0.6;
      cursor: default;
    }
  `,
);
